<script>
  import { createEventDispatcher } from "svelte"

  import HorizontalScrollContainer from "../HorizontalScrollContainer.svelte"
  import Typetester from "./components"

  export let widths
  export let weights
  export let styles

  let selectableOpen = false

  const dispatch = createEventDispatcher()

  const backgroundColors = {
    weights: "var(--grey-extra-light)",
    widths: "var(--grey-light)",
    styles: "var(--grey)",
  }

  $: attributeGroups = {
    weights: weights,
    widths: widths,
    styles: styles,
  }
  $: attributeGroupEntries = Object.entries(attributeGroups)
  $: selectableWidths = widths.filter((w) => !w.selected)
  $: selectableWeights = weights.filter((w) => !w.selected)
  $: selectableStyles = styles.filter((w) => !w.selected)
  $: hasSelectables =
    !!selectableWeights.length ||
    !!selectableWidths.length ||
    !!selectableStyles.length
  $: if (!hasSelectables) {
    selectableOpen = false
  }

  function refresh(event) {
    pickRandomAttributes()
    dispatch("refresh", event)
  }

  function pickRandomAttributes() {
    widths.forEach((w) => (w.selected = false))
    widths[Math.floor(Math.random() * widths.length)].selected = true
    weights.forEach((w) => (w.selected = false))
    weights[Math.floor(Math.random() * weights.length)].selected = true
    styles.forEach((w) => (w.selected = false))
    styles[Math.floor(Math.random() * styles.length)].selected = true
  }

  function onToggleSelector(event) {
    selectableOpen = event.detail.toggled
  }

  function onToggleAttribute(event) {
    dispatch("toggle", event)
  }
</script>

<div class="root">
  <div class="row">
    <div class="attributes">
      <HorizontalScrollContainer>
        {#each attributeGroupEntries as [name, attributes]}
          <div class={name}>
            <Typetester.AttributeToggleGroup
              action={"deselect"}
              bind:attributes
              on:toggle={onToggleAttribute}
              backgroundColor={backgroundColors[name]}
            />
          </div>
        {/each}
      </HorizontalScrollContainer>
    </div>
    <Typetester.RefreshButton on:click={refresh} />
    <Typetester.AttributesSelectorToggle
      toggled={selectableOpen}
      disabled={!hasSelectables}
      on:toggle={onToggleSelector}
    />
  </div>

  {#if selectableOpen}
    <div class="row selectable">
      <HorizontalScrollContainer>
        {#each attributeGroupEntries as [name, attributes]}
          <div class={name}>
            <Typetester.AttributeToggleGroup
              action={"select"}
              bind:attributes
              on:toggle={onToggleAttribute}
              backgroundColor={backgroundColors[name]}
            />
          </div>
        {/each}
      </HorizontalScrollContainer>
    </div>
  {/if}
</div>

<style>
  .root {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    flex-direction: column;
    user-select: none;
    position: relative;
    min-width: 0;
  }

  .row {
    display: flex;
    flex-wrap: nowrap;
    max-width: 100%;
  }

  .row > :global(* + *) {
    margin-left: var(--button-spacing);
  }

  .attributes {
    display: flex;
    flex-wrap: nowrap;
    max-width: 100%;
    overflow-x: hidden;
    width: calc(100% - (var(--line-height-m) * 1.5 + var(--button-spacing)));
  }

  .selectable {
    position: absolute;
    z-index: 2;
    top: calc(100% + var(--button-spacing));
    max-width: calc(100vw - (var(--page-padding) * 2));
    overflow: scroll;
  }

  .weights {
    --background-color: var(--grey-extra-light);
  }

  .widths {
    --background-color: var(--grey-light);
  }

  .styles {
    --background-color: var(--grey);
  }
</style>
